import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=31ff77f3"
import script from "./BasePage.vue?vue&type=script&lang=ts"
export * from "./BasePage.vue?vue&type=script&lang=ts"
import style0 from "./BasePage.vue?vue&type=style&index=0&id=31ff77f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports